export default __webpack_public_path__ + "static/media/A5_LANDSCAPE_ORI_FIX_DF.66964d56.png";